import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { Unknown } from './components';
import LoginPage from './containers/login';
import ForgotPasswordContainer from './containers/forgot-password';
import ResetPasswordContainer from './containers/reset-password';
import SignupContainer from './containers/signup';
import HomeContainer from './containers/home';
import StationListContainer from './containers/station-list';
import StationProfileContainer from './containers/station-profile';
import FuelPricesContainer from './containers/fuel-prices';
import StationReviewsContainer from './containers/station-reviews';
import StationRatingsContainer from './containers/station-ratings';
import CompetitorBenchmarkingContainer from './containers/competitor-benchmarking';
import BrandEngagementContainer from './containers/brand-engagement';
import AlertManagementContainer from './containers/alert-management';
import UserManagementContainer from './containers/user-management';
import EmergencyStationUpdatesContainer from './containers/emergency-station-updates';
import OutageTrackerContainer from './containers/outage-tracker';
import SuggestedEdits from './containers/suggested-edits';
import StationSuggestedEdits from './containers/station-suggested-edits';
import ReviewReplies from './containers/review-replies';

function prefixedPath(prefix, path) {
  // Two slashes means an absolute path
  if (path && path.substring(0, 2) === '//') {
    return path.substring(1);
  }
  if (path) {
    return `${prefix}${path}`;
  }
  return prefix || '/';
}

function populatePathArray(pathArray, prefix, routeSpec) {
  const { routes, ...rest } = routeSpec || {};
  let routesToRecurse = rest;
  if (Array.isArray(routes)) {
    for (const r of routes) {
      pathArray.push({
        ...r,
        key: pathArray.length,
        path: prefixedPath(prefix, r.path),
      });
    }
  } else if (typeof routes === 'object') {
    routesToRecurse = routeSpec;
  }
  if (routesToRecurse) {
    for (const [subpath, spec] of Object.entries(routesToRecurse)) {
      populatePathArray(pathArray, `${prefix}/${subpath}`, spec);
    }
  }
}

const RouterThunk = (routes) => {
  const paths = [];
  populatePathArray(paths, '', routes);

  // in here until react-router-config cleans up it's act
  return () => (
    <Switch>
      {paths.map(route => (
        <Route
          exact={route.exact}
          key={route.key}
          path={route.path}
          strict={route.strict}
          render={props => (
            <route.component {...props} route={route} />
          )}
        />
      ))}
    </Switch>
  );
};

const routes = {
  routes: [
    { component: LoginPage, exact: true, path: '/login.html' },
    { component: ForgotPasswordContainer, exact: true, path: '/forgot-password.html' },
    { component: ResetPasswordContainer, exact: true, path: '/reset-password.html' },
    { component: SignupContainer, exact: true, path: '/signup' },
    { component: HomeContainer, exact: true, path: '/client/home' },
    { component: StationListContainer, exact: true, path: '/client/station-profiles/station-list' },
    { component: StationProfileContainer, exact: true, path: '/client/station-profiles/station-profile' },
    { component: StationProfileContainer, exact: true, path: '/client/station-profiles/station-profile.html' },
    { component: FuelPricesContainer, exact: true, path: '/client/station-profiles/fuel-prices' },
    { component: StationReviewsContainer, exact: true, path: '/client/station-profiles/reviews' },
    { component: StationReviewsContainer, exact: true, path: '/client/station-profiles/reviews.html' },
    { component: ReviewReplies, extract: true, path: '/client/station-profiles/review-reply-templates' },
    { component: SuggestedEdits, exact: true, path: '/client/my-listings/suggested-edits' },
    { component: StationSuggestedEdits, exact: true, path: '/client/my-listings/suggested-edits/:stationId' },
    { component: StationRatingsContainer, exact: true, path: '/client/engagement-analytics/station-ratings' },
    { component: StationRatingsContainer, exact: true, path: '/client/engagement-analytics/station-ratings.html' },
    { component: CompetitorBenchmarkingContainer, exact: true, path: '/client/engagement-analytics/brand-benchmark' },
    { component: BrandEngagementContainer, exact: true, path: '/client/engagement-analytics/brand-engagement' },
    { component: BrandEngagementContainer, exact: true, path: '/client/engagement-analytics/brand-engagement.html' },
    { component: UserManagementContainer, exact: true, path: '/client/users/manage-users' },
    { component: UserManagementContainer, exact: true, path: '/client/users/manage-users.html' },
    { component: AlertManagementContainer, exact: true, path: '/client/alerts' },
    { component: AlertManagementContainer, exact: true, path: '/client/alerts.html' },
    { component: EmergencyStationUpdatesContainer, exact: true, path: '/client/emergency/station-updates' },
    { component: OutageTrackerContainer, exact: true, path: '/client/emergency/outage-tracker' },
  ],
  final: {
    routes: [
      { component: Unknown, path: '//' },
    ],
  },
};

export const Router = RouterThunk(routes);
